<template>
    <header id="header" class="header" :class="{'white' : theme == 'white'}">
        <nav class="header-outline d-flex justify-content-between">
            <!-- Logo -->
            <router-link to="/" tag="div" class="logo">
                <span @click="closeMenu(1)">   
                    <svg version="1.1" id="black" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 475.456 55.83" style="enable-background:new 0 0 475.456 55.83;" xml:space="preserve">
                        <polygon points="245.573,2.786 234.404,2.786 234.404,22.331 214.863,22.331 214.863,33.498 234.404,33.498 234.404,53.039 245.573,53.039 245.573,33.498 265.106,33.498 265.106,22.331 245.573,22.331"/>
                        <polygon points="475.456,13.954 475.456,2.786 447.547,2.786 447.547,53.039 475.456,53.039 475.456,41.875 458.711,41.875 458.711,33.498 475.456,33.498 475.456,22.331 458.711,22.331 458.711,13.954"/>
                        <polygon points="368.14,22.331 351.387,22.331 351.387,2.786 340.231,2.786 340.231,53.039 351.387,53.039 351.387,33.498 368.14,33.498 368.14,53.039 379.312,53.039 379.312,2.786 368.14,2.786"/>
                        <rect x="390.476" y="2.786" width="11.164" height="50.253"/>
                        <polygon points="407.843,2.786 407.843,13.954 419.015,13.954 419.015,53.039 430.171,53.039 430.171,13.954 441.343,13.954 441.343,2.786"/>
                        <polygon points="313.396,36.451 305.625,2.786 305.286,2.786 295.665,2.786 295.326,2.786 287.555,36.451 278.532,2.786 266.972,2.786 280.438,53.039 293.686,53.039 300.471,23.627 307.257,53.039 320.505,53.039 333.971,2.786 322.419,2.786"/>
                        <path d="M27.917,11.163c7.294,0,13.482,4.665,15.78,11.168h11.588C52.696,9.588,41.431,0,27.917,0C12.504,0,0,12.497,0,27.913C0,43.33,12.505,55.83,27.917,55.83c13.514,0,24.779-9.592,27.368-22.331H43.697c-2.298,6.503-8.486,11.168-15.78,11.168c-9.25,0-16.738-7.504-16.738-16.754C11.18,18.663,18.668,11.163,27.917,11.163z"/>
                        <polygon points="148.527,21.325 138.85,3.109 126.2,3.109 142.953,34.621 142.953,53.039 154.117,53.039 154.117,34.609 170.871,3.109 158.22,3.109"/>
                        <polygon points="215.017,2.786 201.389,2.786 188.238,21.567 188.238,2.786 177.067,2.786 177.067,53.039 188.238,53.039 188.238,32.638 202.512,53.039 216.156,53.039 197.996,27.101"/>
                        <polygon points="101.408,2.786 92.127,36.083 82.853,2.786 64.21,2.786 64.21,53.039 75.381,53.039 75.381,11.64 86.909,53.039 87.417,53.039 96.86,53.039 97.361,53.039 108.889,11.64 108.889,53.039 120.044,53.039 120.044,2.786"/>
                    </svg>
                </span>
            </router-link>

            <!-- Navigation -->
            <div id="menu-box" class="menu-box" :class="{'opened' : menuOpen}">
                <div class="navi">
                    <router-link to="/who-we-are" tag="a" class="main-menu whoweare"><span @click="closeMenu(2)">Who we are</span></router-link>
                    <router-link to="/what-we-do" tag="a" class="main-menu whatwedo"><span  @click="closeMenu('')">What we do</span></router-link> 
                    <a class="main-menu" href="https://www.designplusshop.com/" target="_blank">DESIGN + SHOP</a>
                    <router-link to="/contact" tag="a" class="main-menu menu-contactus contactus"><span @click="closeMenu(7)">Contact us</span></router-link>

                    <div class="contact-info">
                        CMYK+WHITE, Inc.<br>
                        49 W 38th Street, 4th Floor.<br>
                        New York NY, 10018<br><br>

                        T 212.302.1460 <br>
                        <!-- 212.302.1497<br><br> -->

                        For any inquiries or questions, please email us at <a class="mailto" href="mailto:careers@cmykpluswhite.com">info@cmykpluswhite.com</a>
                    </div>
                </div>
            </div>

            <div class="menu-bt" :class="{'opened' : menuOpen}" @click="openMenu()">
                <svg version="1.1" id="black" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.8 55.8" style="enable-background:new 0 0 55.8 55.8;" xml:space="preserve">
                    <polygon points="33.3,2.8 22.1,2.8 22.1,22.3 2.6,22.3 2.6,33.5 22.1,33.5 22.1,53 33.3,53 33.3,33.5 52.8,33.5 52.8,22.3 33.3,22.3 "/>
                </svg>

            </div>
        </nav>
    </header>
</template>


<script>
import { EventBus }     	from '../../event-bus.js';

export default {
    name: 'app-header',
    data() {
        return {
            menuOpen    : false,
            theme       : ''
        }
    },
    created() {
        EventBus.$on('theme', (v) => {
            (v == 'white') ? this.theme = 'white' : this.theme = ''
        })

        EventBus.$on('targetPage', (pg) => {
            this.pgn = pg
            var wwa = document.querySelector('.whoweare')
            var ctu = document.querySelector('.contactus')
            var wwd = document.querySelector('.whatwedo')

            wwd.style.textDecoration = "none"

            if(pg > 1 && pg < 7) {
                wwa.style.textDecoration = "underline"
                ctu.style.textDecoration = "none"
            }else if(pg == 7) {
                wwa.style.textDecoration = "none"
                ctu.style.textDecoration = "underline"
            }else if(pg == 1 ) {
                wwa.style.textDecoration = "none"
                ctu.style.textDecoration = "none"
            }
        })
       
    },
    mounted() {
        window.addEventListener("resize", this.resize)     
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize)
    },
    methods: {
        openMenu() {
            const menuBox   = document.getElementById('menu-box')
            const winW      = document.body.clientWidth

            if(winW < 768) { 
                if(this.menuOpen) {
                    this.menuOpen = !this.menuOpen
                    setTimeout(() => {
                        menuBox.style.visibility = 'hidden'
                    }, 500)
                }else{
                    menuBox.style.visibility = 'visible'
                    this.menuOpen = !this.menuOpen
                }
            }
        },
        closeMenu(no) {
            const menuBox   = document.getElementById('menu-box')
            const winW      = document.body.clientWidth

            if(winW < 768) { 
                this.menuOpen = false
                setTimeout(() => {
                    menuBox.style.visibility = 'hidden'
                }, 500)
            }

            if(no) {
                EventBus.$emit('menu', '')
                EventBus.$emit('menu', no)
            }
        },
        resize() {
            const winW      = document.body.clientWidth
            const menuBox   = document.getElementById('menu-box')
            if(winW >= 768) { 
                menuBox.style.visibility = 'visible'
            }else if(!this.menuOpen){
                menuBox.style.visibility = 'hidden'
            }
        },
    },
    watch: {
        menuOpen(v) {
            (v) ? document.body.className = 'popup-view' : document.body.className = ''
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/pages/header.scss';
</style>


// WEBPACK FOOTER //
// src/pages/common/header.vue